export default "__VITE_ASSET__BN0CCdBH__"